export default __webpack_public_path__ + "static/drew-f2685c87da1d5e3c8f33b39c0dcf8b52.jpeg";